import { render, staticRenderFns } from "./ShopUserList.vue?vue&type=template&id=0664c5c8&scoped=true&lang=pug&"
import script from "./ShopUserList.vue?vue&type=script&lang=ts&"
export * from "./ShopUserList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664c5c8",
  null
  
)

export default component.exports